import type { ErreurApi } from './types'

/**
 * Erreur d'API typée, portant le `code` machine et le `champ` fautif.
 *
 * Le frontend teste `code`, jamais le texte : `detail` est destiné à l'humain
 * et peut être reformulé sans préavis. Analyser le français pour décider d'un
 * comportement, c'est se condamner à casser à la première correction de faute
 * d'orthographe côté backend.
 */
export class ApiError extends Error {
  readonly statut: number
  readonly code: string
  readonly champ: string | null

  constructor(statut: number, corps: Partial<ErreurApi>) {
    super(corps.detail ?? 'Une erreur est survenue.')
    this.name = 'ApiError'
    this.statut = statut
    this.code = corps.code ?? 'ERREUR'
    this.champ = corps.champ ?? null
  }

  get estAuthentification(): boolean {
    return this.statut === 401
  }

  get estDroits(): boolean {
    return this.statut === 403
  }

  get estConflitPlanning(): boolean {
    return this.statut === 409 && this.code === 'CONFLIT_PLANNING'
  }
}

/**
 * Panne réseau — distincte d'une erreur serveur.
 *
 * Un backend injoignable et un backend qui répond 500 n'appellent pas le même
 * message : le premier se réessaie, le second se signale.
 */
export class ErreurReseau extends Error {
  constructor(cause?: unknown) {
    super("Le serveur est injoignable. Vérifiez votre connexion, puis réessayez.")
    this.name = 'ErreurReseau'
    this.cause = cause
  }
}
